
import { ReactNode, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import PageTransition from "./PageTransition";

const PageLoading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-cottage-200 border-t-cottage-600 rounded-full animate-spin"></div>
  </div>
);

const ErrorFallback = ({ error }: { error: Error }) => (
  <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-cottage-50">
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
      <h2 className="text-2xl font-bold text-cottage-800 mb-4">Something went wrong</h2>
      <p className="text-cottage-600 mb-4">
        An error occurred while rendering this page. Please try refreshing the browser.
      </p>
      <pre className="bg-cottage-50 p-4 rounded text-sm overflow-auto max-h-56 mb-4">
        {error.message}
      </pre>
      <button
        className="bg-cottage-600 hover:bg-cottage-700 text-white px-4 py-2 rounded transition-colors"
        onClick={() => window.location.reload()}
      >
        Refresh Page
      </button>
    </div>
  </div>
);

interface LazyRouteProps {
  children: ReactNode;
}

const LazyRoute = ({ children }: LazyRouteProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={<PageLoading />}>
        <PageTransition>{children}</PageTransition>
      </Suspense>
    </ErrorBoundary>
  );
};

export default LazyRoute;
